import { jsx as _jsx } from "react/jsx-runtime";
import { ElementIds } from '@/Constants/ElementIDs';
import { classNames } from '@standardnotes/snjs';
import { forwardRef } from 'react';
import { EditorMargins, EditorMaxWidths } from '../EditorWidthSelectionModal/EditorWidths';
import { useAvailableSafeAreaPadding } from '@/Hooks/useSafeAreaPadding';
export const EditorContentWithSafeAreaPadding = forwardRef(function EditorContentWithSafeAreaPadding({ editorLineWidth, children, }, ref) {
    const { hasBottomInset } = useAvailableSafeAreaPadding();
    return (_jsx("div", { id: ElementIds.EditorContent, className: classNames(ElementIds.EditorContent, 'z-editor-content overflow-auto sm:[&>*]:mx-[var(--editor-margin)] sm:[&>*]:max-w-[var(--editor-max-width)]', hasBottomInset && 'pb-safe-bottom'), style: {
            '--editor-margin': EditorMargins[editorLineWidth],
            '--editor-max-width': EditorMaxWidths[editorLineWidth],
        }, ref: ref, children: children }));
});
